import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import propertyViewingsService from '../services/propertyViewingsService';

const PropertyViewingsCopy = () => {
  const { id, period } = useParams();
  const navigate = useNavigate();
  const [viewing, setViewing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    loadViewingDetails();
  }, [id]);

  const loadViewingDetails = async () => {
    try {
      setLoading(true);
      const response = await propertyViewingsService.getViewingDetails(id);
      setViewing(response.data);
    } catch (error) {
      console.error('Error loading viewing details:', error);
      toast.error('Failed to load viewing details.');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = async () => {
    try {
      setSubmitting(true);
      await propertyViewingsService.copyViewing(id, period);
      toast.success('Successfully copied viewing.');
      navigate('/property_viewings');
    } catch (error) {
      console.error('Error copying viewing:', error);
      toast.error('Failed to copy viewing.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  if (!viewing) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3>Copy Viewing</h3>
              </div>
              <div className="panel-body">
                <p>Viewing not found.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <div className="panel panel-default">
            <div className="panel-heading">
              <h3>Copy Viewing</h3>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-6">
                  <h4>Original Viewing</h4>
                  <p><strong>Property:</strong> {viewing.property?.name || 'N/A'}</p>
                  <p><strong>Date:</strong> {viewing.day || 'N/A'}</p>
                  <p><strong>Time:</strong> {viewing.time_from} - {viewing.time_to}</p>
                  <p><strong>Attendees:</strong> {viewing.attendees || 'N/A'}</p>
                </div>
                <div className="col-md-6">
                  <h4>Copy Settings</h4>
                  <p><strong>Period:</strong> {period || 'N/A'}</p>
                  <p><strong>Action:</strong> Copy this viewing to the next period</p>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <button 
                    className="btn btn-primary me-2" 
                    onClick={handleCopy}
                    disabled={submitting}
                  >
                    {submitting ? 'Copying...' : 'Copy Viewing'}
                  </button>
                  <button 
                    className="btn btn-secondary" 
                    onClick={() => navigate('/property_viewings')}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyViewingsCopy; 